import * as React from 'react'
import { DropdownConnected } from './DropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DropdownExamples = () => {
  return (
    <div className="DropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DropdownConnected />
      </Provider>
    </div>
  )
}
